import { createContext } from 'react';

const StorylaneContext = createContext();

export default StorylaneContext;